// this file contains only services used in the standalone embedded order form
// do not use it in regular build, as the module registration is already done within the services.js
import { registerServiceModule } from '@/genericStoreService'

import grpcCommon from '@/proto/common/common_pb'
import grpcCustomer from '@/proto/customer/customer_grpc_web_pb'
import grpcCustomerPb from '@/proto/customer/customer_pb'

// Create alias for StudentDocument as Document to work around genericStoreService limitation
// When it processes documentsList, it removes 'List' and 's' to get 'Document'
grpcCustomerPb.Document = grpcCustomerPb.StudentDocument

export default store => {
  registerServiceModule(store, {
    name: 'orderFormService',
    service: {
      import: grpcCustomer,
      address: process.env.VUE_APP_API_URL,
      paginationObjectType: null,
      typeImports: [grpcCommon, grpcCustomerPb],
      typeMappings: {
        'invoiceAddress': 'Address',
        'deliveryAddress': 'Address',
        'billingAddress': 'Address', // For RegisterStudent
        // RegisterStudent nested address fields
        'registerStudent.billingAddress': 'Address',
        'registerStudent.deliveryAddress': 'Address',
        // Direct mapping for document type (singular form after List removal)
        'documents': 'StudentDocument',
        'document': 'StudentDocument' // Also map singular in case
      }
    },
    manualActions: true,
    actions: {
      get: {
        getOrderFormV2Grouped: {}
      },
      trigger: {
        authenticate: {},
        createOrder: {},
        getOrderSummary: {},
        clearProductQuantities: {},
        getOrders: {},
        requestNewPasswordToken: {},
        saveNewPassword: {},
        validateAddress: {},
        registerStudent: {},
        verifyStudentEmail: {},
        getStudentStatus: {}
      },
      download: {
        downloadInvoicePDF: {}
      }
    },
    hooks: {
      autoLoad: async ({ dispatch }) => {
        dispatch('ui/preload', null, { root: true })
      },
      // LOGGING ACTIONS ---- not awaited!
      error: (err) => {
        // eslint-disable-next-line no-console
        console.error(err)
      },
      info: (info) => {
        // eslint-disable-next-line no-console
        console.info(info)
      },
      warning: (warn) => {
        // eslint-disable-next-line no-console
        console.warn(warn)
      }
    }
  })
}
